export const PageDataState = {
    Searchs: {
        th_name: {
            type: 'text',
            id: 'th_name',
            label: 'หลักสูตร',
            value: '',
            placeholder: 'ชื่อหลักสูตร',
        },
        keyword: {
            type: 'text',
            id: 'keyword',
            label: 'คีย์เวิร์ด',
            value: '',
            placeholder: 'คีย์เวิร์ด',
        },
        academy_id: {
            type: 'select',
            id: 'academy_id',
            label: 'สถานศึกษา',
            value: '',
            placeholder: 'สถานศึกษา',
        },
        enterprise_id: {
            type: 'select',
            id: 'enterprise_id',
            label: 'ผู้ประกอบการ',
            value: '',
            placeholder: 'ผู้ประกอบการ',
        },
        target_industries_id: {
            type: 'select',
            id: 'target_industries_id',
            label: 'อุตสาหกรรม',
            value: '',
            placeholder: 'อุตสาหกรรม',
        },
        target_group: {
            type: 'text',
            id: 'target_group',
            label: 'กลุ่มเป้าหมาย',
            value: '',
            placeholder: 'กลุ่มเป้าหมาย',
        },
        operation: {
            type: 'select',
            id: 'operation',
            label: 'การดำเนินงาน',
            value: '',
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะหลักสูตร',
            value: '',
        },
        official_course_code: {
            type: 'text',
            id: 'official_course_code',
            label: 'รหัสหลักสูตร',
            value: '',
            placeholder: 'รหัสหลักสูตร',
        }, 
        benefits_id: {
            type: 'select',
            id: 'benefits_id',
            label: 'สิทธิประโยชน์',
            value: '',
            placeholder: 'สิทธิประโยชน์',
        },
        course_type: {
            type: 'select',
            id: 'course_type',
            label: 'ประเภทหลักสูตร',
            value: '',
            placeholder: 'สิทธิประโยชน์',
        },

        self_academy_check: {
            type: 'checkbox',
            group: 'eec-hdc',
            id: 'self_academy_check',
            label: 'เฉพาะหลักสูตรที่ผู้ใช้งานร่วมสถานศึกษาสร้าง',
            value: '',
            placeholder: 'เฉพาะหลักสูตรที่ผู้ใช้งานร่วมสถานศึกษาสร้าง',
        },
        self_users_check: {
            type: 'checkbox',
            group: 'eec-hdc',
            id: 'self_users_check',
            label: 'เฉพาะหลักสูตรที่ผู้ใช้งานสร้าง',
            value: '',
            placeholder: 'เฉพาะหลักสูตรที่ผู้ใช้งานสร้าง',
        },
        created_by_type: {
            type: 'text',
            id: 'created_by_type',
            label: 'ประเภทผู้ใช้งาน',
            value: '',
            placeholder: 'ประเภทผู้ใช้งาน',
        },
        created_by_id: {
            type: 'text',
            id: 'created_by_id',
            label: 'รหัสผู้ใช้งาน',
            value: '',
            placeholder: 'รหัสผู้ใช้งาน',
        }, 
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        course_type: {
            type: 'text',
            id: 'course_type',
            label: 'ประเภทหลักสูตร',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        th_name: {
            type: 'text',
            id: 'th_name',
            label: 'ชื่อหลักสูตร',
            // label: 'ชื่อหลักสูตร (ภาษาไทย)',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        en_name: {
            type: 'text',
            id: 'en_name',
            label: 'ชื่อหลักสูตร (ภาษาอังกฤษ)',
            value: '',
            validator: {
                type: 'text',
                required: false
            },
            error: { status: null, msg: '' }
        },
        keyword: {
            type: 'text',
            id: 'keyword',
            label: 'คีย์เวิร์ด',
            value: '',
            validator: {
                type: 'text',
                required: false
            },
            error: { status: null, msg: '' }
        },
        academy_id: {
            type: 'select',
            id: 'academy_id',
            label: 'สถานศึกษาผู้รับผิดชอบหลักสูตร',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        enterprise_id: {
            type: 'select',
            id: 'enterprise_id',
            label: 'ผู้ประกอบที่ประสงค์เข้ารับการอบรม',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        benefits_id: {
            type: 'select',
            id: 'benefits_id',
            label: 'สิทธิประโยชน์',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        }, 
        target_industries_id: {
            type: 'select',
            id: 'target_industries_id',
            label: 'อุตสาหกรรมเป้าหมาย',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        batch_count: {
            type: 'text',
            id: 'batch_count',
            label: 'จำนวนผู้เข้าอบรม',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 1000
            },
            error: { status: null, msg: '' }
        },
        people_per_batch: {
            type: 'text',
            id: 'people_per_batch',
            label: 'รุ่นละ',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 1000
            },
            error: { status: null, msg: '' }
        },
        total_people: {
            type: 'text',
            id: 'total_people',
            label: 'รวมทั้งสิ้น',
            value: '',
            validator: {
                type: 'number',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        training_start_month: {
            type: 'select',
            id: 'training_start_month',
            label: 'กำหนดการฝึกอบรม เริ่มต้น',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 2
            },
            error: { status: null, msg: '' }
        },
        training_start_year: {
            type: 'select',
            id: 'training_start_year',
            label: 'ปี',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 4
            },
            error: { status: null, msg: '' }
        },
        training_end_month: {
            type: 'select',
            id: 'training_end_month',
            label: 'กำหนดการฝึกอบรม สิ้นสุด',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 2
            },
            error: { status: null, msg: '' }
        },
        training_end_year: {
            type: 'select',
            id: 'training_end_year',
            label: 'ปี',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 4
            },
            error: { status: null, msg: '' }
        },
        training_duration: {
            type: 'text',
            id: 'training_duration',
            label: 'ระยะเวลาการฝึกอบรม',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        budget_per_batch: {
            type: 'text',
            id: 'budget_per_batch',
            label: 'งบประมาณต่อรุ่น',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 100,
                max: 1000000
            },
            error: { status: null, msg: '' }
        },
        total_budget: {
            type: 'text',
            id: 'total_budget',
            label: 'งบประมาณรวมทั้งสิ้น',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 100,
                max: 10000000
            },
            error: { status: null, msg: '' }
        },
        budget_per_person: {
            type: 'text',
            id: 'budget_per_person',
            label: 'งบประมาณต่อคน',
            value: '',
            validator: {
                type: 'number',
                required: false,
                min: 100,
                max: 1000000
            },
            error: { status: null, msg: '' }
        },
        target_group: {
            // type: 'textarea',
            // rows: 3,
            id: 'target_group',
            label: 'กลุ่มเป้าหมาย',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        }, 
        course_importance: {
            type: 'textarea',
            rows: 5,
            id: 'course_importance',
            label: 'ที่มาและความสำคัญ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        },
        academy_signer_name: {
            type: 'text',
            id: 'academy_signer_name',
            label: 'ผู้บริหารสถานศึกษา',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        academy_signer_position: {
            type: 'text',
            id: 'academy_signer_position',
            label: 'ตำแหน่ง',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        academy_sign_date: {
            type: 'text',
            id: 'academy_sign_date',
            label: 'วันที่ลงนาม',
            value: '',
            validator: {
                type: 'date',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        enterprise_signer_name: {
            type: 'text',
            id: 'enterprise_signer_name',
            label: 'ผู้ประกอบการ',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        enterprise_signer_position: {
            type: 'text',
            id: 'enterprise_signer_position',
            label: 'ตำแหน่ง',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        enterprise_sign_date: {
            type: 'text',
            id: 'enterprise_sign_date',
            label: 'วันที่ลงนาม',
            value: '',
            validator: {
                type: 'date',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        office_signer_name: {
            type: 'text',
            id: 'office_signer_name',
            label: 'เจ้าหน้าที่',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        office_sign_date: {
            type: 'text',
            id: 'office_sign_date',
            label: 'วันที่ตรวจสอบ',
            value: '',
            validator: {
                type: 'date',
                required: false,
            },
            error: { status: null, msg: '' }
        }, 
        operation: {
            type: 'select',
            id: 'operation',
            label: 'สถานะการดำเนินงาน',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะหลักสูตร',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        official_course_code: {
            type: 'text',
            id: 'official_course_code',
            label: 'รหัสหลักสูตร',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 15,
                maxLength: 15
            },
            error: { status: null, msg: '' }
        },
        operation_comment: {
            type: 'textarea',
            rows : 3,
            id: 'operation_comment',
            label: 'ความคิดเห็น',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        }, 
        approve_condition: {
            type: 'textarea',
            rows : 3,
            id: 'approve_condition',
            label: 'เงื่อนไขการรับรองหลักสูตร',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        },
        approve_file: {
            type: 'file',
            id: 'approve_file',
            label: 'เอกสารการรับรอง',
            fileId: '',
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: false,
                accept: "application/pdf,application/msword,image/png,image/jpeg",
            },
            error: { status: null, msg: '' }
        },
    },
    ReadOnlys: {
        academy_code: {
            id: 'academy_code',
            label: 'รหัส'
        },
        coordinator: {
            id: 'coordinator',
            label: 'ผู้ประสานงาน'
        },
        coordinator_phone: {
            id: 'coordinator_phone',
            label: 'โทรศัพท์'
        },
        coordinator_email: {
            id: 'coordinator_email',
            label: 'อีเมล'
        }                 
    },
    InputGroup: {
        Checkbox: {
            search_eec_hdc: {
                display: 'inline',
                label: 'EEC-HDC',
                inputs: [
                        {id: 'self_academy_check', value: '1'},
                        {id: 'self_users_check', value: '1'},
                ],
                validator: {
                    type: 'checkbox',
                    required: false,
                },
                error: { status: null, msg: '' },
            },
            input_eec_hdc: {
                display: 'inline',
                label: '',
                inputs: [
                        {id: 'self_academy_check', value: '1'},
                        {id: 'self_users_check', value: '1'},
                ],
                validator: {
                    type: 'checkbox',
                    required: false,
                },
                error: { status: null, msg: '' },
            }            
        }        
    },
    Approved: false,
}